import React from 'react';
import './FilterButton.scss';

export const FilterButton = ({ onClick, children }) => (
    <div className={'filter-button'} onClick={onClick}>
        {children}
    </div>
);
